import React from "react";
import TradingViewWidget from "react-tradingview-widget";
import { Container, Row, Col, Button, Form, Modal, Dropdown } from "react-bootstrap";
import {
    BTC_logo, ETH_logo, USDT_logo, XRP_logo, BCH_logo,
    BSV_logo, LTC_logo, BNB_logo, EOS_logo, XTZ_logo,
    ETC_logo, BTS_logo
} from "../img";
import { UserService, ExchangeService, AuthService, TradeService } from "../services";
import AppHeader from "../components/AppHeader";
import "./Coin.css";

// Define Coin Map with verified Binance symbols
const COIN_MAP = [
    { code: 'BTC', name: 'bitcoin', symbol: 'BTCUSDT', img: BTC_logo, isActive: true },
    { code: 'ETH', name: 'ethereum', symbol: 'ETHUSDT', img: ETH_logo, isActive: true },
    { code: 'USDT', name: 'tether', symbol: 'USDTUSDT', img: USDT_logo, isActive: false }, // Not traded on Binance
    { code: 'XRP', name: 'xrp', symbol: 'XRPUSDT', img: XRP_logo, isActive: true },
    { code: 'BCH', name: 'bitcoinCash', symbol: 'BCHUSDT', img: BCH_logo, isActive: true },
    { code: 'BSV', name: 'bitcoinSV', symbol: 'BSVUSDT', img: BSV_logo, isActive: false }, // Not active on Binance
    { code: 'LTC', name: 'litecoin', symbol: 'LTCUSDT', img: LTC_logo, isActive: true },
    { code: 'BNB', name: 'binancecoin', symbol: 'BNBUSDT', img: BNB_logo, isActive: true },
    { code: 'EOS', name: 'eos', symbol: 'EOSUSDT', img: EOS_logo, isActive: true },
    { code: 'XTZ', name: 'tezos', symbol: 'XTZUSDT', img: XTZ_logo, isActive: true },
    { code: 'ETC', name: 'ethereumClassic', symbol: 'ETCUSDT', img: ETC_logo, isActive: true },
    { code: 'BTS', name: 'bitshares', symbol: 'BTSUSDT', img: BTS_logo, isActive: false }, // Not active on Binance
];

// List of coins that are actually available on Binance
const ACTIVE_BINANCE_COINS = ['BTC', 'ETH', 'XRP', 'BCH', 'LTC', 'BNB', 'EOS', 'XTZ', 'ETC'];

export default class Coin extends React.Component {
    constructor(props) {
        super(props);

        this.openTradeModal = this.openTradeModal.bind(this);
        this.submitOrder = this.submitOrder.bind(this);
        this.selectTime = this.selectTime.bind(this);
        this.changeCoin = this.changeCoin.bind(this);
        this.fetchAllData = this.fetchAllData.bind(this);
        this.updateGlobalBalance = this.updateGlobalBalance.bind(this);
        this.getBalance = this.getBalance.bind(this);
        this.clearCachedData = this.clearCachedData.bind(this);
        this.redirectToLogin = this.redirectToLogin.bind(this);
        this.fetchCoinDataFromBinance = this.fetchCoinDataFromBinance.bind(this);
        this.fetchCoinDataFromExchangeService = this.fetchCoinDataFromExchangeService.bind(this);

        // Get coin from URL parameter
        const urlParam = this.props.match.params.coin || 'btc';
        const initialCoin = this.getCoinDataFromParam(urlParam);

        console.log("💰 Initial Coin from URL:", urlParam, "->", initialCoin);

        this.state = {
            symbol: initialCoin.code.toLowerCase(),
            coinName: initialCoin.name,
            coinSymbol: initialCoin.symbol,
            currentUser: AuthService.getCurrentUser(),
            price: "0.00",
            logo: initialCoin.img,
            isActiveCoin: initialCoin.isActive,

            // Stats - initialized with placeholder values
            changeD: "0.00", 
            high24: "0.00", 
            low24: "0.00", 
            vol24: "0", 
            volCoin: "0.00", 
            priceChange: "0.00", 
            txCount: "0",

            // Trading
            showTradeModal: false, 
            tradeDirection: '', 
            selectedTime: 30, 
            profitPercent: 20, 
            tradeAmount: '',
            loading: false, 
            tradeResult: null, 
            showResultModal: false,
            currentUSD: "0.00",

            // Track API status
            apiError: false,
            isLoadingData: true,
            
            lastAPICallTime: 0,
            hasRedirected: false
        };
    }

    // Helper to find coin data from URL param
    getCoinDataFromParam(param) {
        const lowerParam = param.toLowerCase();
        console.log("🔍 Searching for coin with param:", lowerParam);
        
        // Try to find by code first (BTC, ETH, etc.)
        const foundByCode = COIN_MAP.find(c => c.code.toLowerCase() === lowerParam);
        if (foundByCode) {
            console.log("✅ Found by code:", foundByCode);
            return foundByCode;
        }
        
        console.log("❌ Coin not found, defaulting to BTC");
        return COIN_MAP[0];
    }

    redirectToLogin() {
        if (!this.state.hasRedirected) {
            console.log("🔀 Redirecting to login...");
            this.setState({ hasRedirected: true }, () => {
                this.props.history.push("/login");
            });
        }
    }

    clearCachedData() {
        return new Promise((resolve) => {
            if ('caches' in window) {
                caches.keys().then(names => {
                    names.forEach(name => {
                        caches.delete(name);
                    });
                });
            }
            resolve();
        });
    }

    async componentDidMount() {
        console.log("🔍 Coin component mounted with:", this.state.coinName);
        
        try {
            await this.clearCachedData();
            
            const currentUser = AuthService.getCurrentUser();
            if (!currentUser) {
                console.log("❌ No user found on mount, redirecting to login");
                this.redirectToLogin();
                return;
            }

            if (AuthService.isAdmin()) {
                this.props.history.push("/admin/dashboard");
                return;
            }

            this.setState({ currentUser });

            this.getBalance();
            this.fetchAllData();

            this.interval = setInterval(() => {
                const now = Date.now();
                if (now - this.state.lastAPICallTime > 25000) {
                    console.log("🔄 Coin: Refreshing data (30s interval)");
                    this.fetchAllData();
                    this.setState({ lastAPICallTime: now });
                }
            }, 30000); 

        } catch (error) {
            console.error("❌ Auth refresh failed:", error);
            this.redirectToLogin();
        }
    }

    componentDidUpdate(prevProps) {
        const currentCoin = this.props.match.params.coin || 'btc';
        const prevCoin = prevProps.match.params.coin || 'btc';
        
        if (currentCoin !== prevCoin) {
            console.log("🔄 Coin changed from", prevCoin, "to", currentCoin);
            
            const newCoin = this.getCoinDataFromParam(currentCoin);
            console.log("🔄 New coin data:", newCoin);

            this.setState({
                symbol: newCoin.code.toLowerCase(),
                coinName: newCoin.name,
                coinSymbol: newCoin.symbol,
                logo: newCoin.img,
                isActiveCoin: newCoin.isActive,
                isLoadingData: true,
                lastAPICallTime: Date.now()
            }, () => {
                this.fetchAllData();
                this.getBalance();
            });
        }
    }

    componentWillUnmount() { 
        if (this.interval) clearInterval(this.interval); 
    }

    // --- DATA FETCHING ---
    fetchAllData() {
        console.log("🔄 Fetching all data for:", this.state.coinName);
        
        this.setState({ isLoadingData: true, apiError: false });
        
        // Check if this is an active Binance coin
        if (ACTIVE_BINANCE_COINS.includes(this.state.symbol.toUpperCase())) {
            console.log("✅ Coin is active on Binance, fetching from Binance API");
            this.fetchCoinDataFromBinance();
        } else {
            console.log("⚠️ Coin may not be active on Binance, using ExchangeService");
            this.fetchCoinDataFromExchangeService();
        }
    }

    fetchCoinDataFromBinance() {
        const tickerSymbol = this.state.coinSymbol.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
        console.log("📊 Fetching from Binance API for:", tickerSymbol);

        const cacheBuster = `?t=${Date.now()}`;
        const apiUrl = `https://api.binance.com/api/v3/ticker/24hr?symbol=${tickerSymbol}${cacheBuster}`;
        
        fetch(apiUrl)
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                console.log("✅ Binance API response:", data);
                
                if (data.code === -1121) {
                    // Symbol not found error
                    console.error("❌ Symbol not found on Binance:", data.msg);
                    this.fetchCoinDataFromExchangeService();
                    return;
                }
                
                // Extract data from Binance response
                const price = parseFloat(data.lastPrice || 0).toFixed(2);
                const high24 = parseFloat(data.highPrice || 0).toFixed(2);
                const low24 = parseFloat(data.lowPrice || 0).toFixed(2);
                const vol24 = parseFloat(data.quoteVolume || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });
                const volCoin = parseFloat(data.volume || 0).toFixed(2);
                const priceChange = parseFloat(data.priceChange || 0).toFixed(2);
                const changeD = parseFloat(data.priceChangePercent || 0).toFixed(2);
                const txCount = parseInt(data.count || 0).toLocaleString();

                this.setState({
                    price,
                    high24,
                    low24,
                    vol24,
                    volCoin,
                    priceChange,
                    changeD,
                    txCount,
                    isLoadingData: false,
                    apiError: false
                });

                console.log("✅ Data updated successfully for", this.state.symbol);
            })
            .catch(err => {
                console.error("❌ Binance API fetch failed:", err);
                this.fetchCoinDataFromExchangeService();
            });
    }

    fetchCoinDataFromExchangeService() {
        console.log("🔄 Using ExchangeService for:", this.state.coinName);
        
        // Try to get price from ExchangeService
        ExchangeService.getCurrentPrice(this.state.coinName)
            .then((price) => {
                console.log("✅ ExchangeService price received:", price);
                
                // Set price from ExchangeService
                this.setState({
                    price: parseFloat(price).toFixed(2),
                    isLoadingData: false,
                    apiError: false
                });

                // Try to get percent change
                ExchangeService.getPercentChange(this.state.coinName)
                    .then((response) => {
                        if (response && response.day) {
                            this.setState({ changeD: response.day });
                        }
                    })
                    .catch(() => {
                        // Ignore error for percent change
                    });

                // Generate simulated stats for non-Binance coins
                this.generateSimulatedStats(parseFloat(price));
            })
            .catch(err => {
                console.error("❌ ExchangeService failed:", err);
                
                // Generate simulated data as fallback
                this.generateSimulatedStats(13.11); // Default price
                this.setState({
                    isLoadingData: false,
                    apiError: true
                });
            });
    }

    generateSimulatedStats(basePrice) {
        console.log("🎲 Generating simulated stats for", this.state.symbol);
        
        // Generate realistic looking simulated data
        const randomChange = (Math.random() * 10 - 5).toFixed(2); // -5% to +5%
        const randomHigh = (basePrice * (1 + Math.random() * 0.1)).toFixed(2); // Up to 10% higher
        const randomLow = (basePrice * (1 - Math.random() * 0.05)).toFixed(2); // Up to 5% lower
        const randomVol = Math.floor(Math.random() * 10000000).toLocaleString();
        const randomCoinVol = (Math.random() * 10000).toFixed(2);
        const randomTx = Math.floor(Math.random() * 10000).toLocaleString();

        this.setState({
            changeD: randomChange,
            high24: randomHigh,
            low24: randomLow,
            vol24: randomVol,
            volCoin: randomCoinVol,
            priceChange: (basePrice * (parseFloat(randomChange) / 100)).toFixed(2),
            txCount: randomTx
        });
    }

    // --- ACTIONS ---
    changeCoin(selectedCoin) {
        console.log("🔄 Changing coin to:", selectedCoin.code);
        this.setState({ 
            symbol: selectedCoin.code.toLowerCase(),
            coinName: selectedCoin.name,
            coinSymbol: selectedCoin.symbol,
            logo: selectedCoin.img,
            isActiveCoin: selectedCoin.isActive,
            isLoadingData: true,
            lastAPICallTime: Date.now()
        }, () => {
            this.fetchAllData();
            this.props.history.push(`/coin/${selectedCoin.code.toLowerCase()}`);
        });
    }

    updateGlobalBalance(newBalance) {
        const fixedBalance = parseFloat(newBalance).toFixed(2);
        this.setState({ currentUSD: fixedBalance });
        
        // Dispatch balance update event for AppHeader and other components
        const event = new CustomEvent("balanceUpdate", { 
            detail: { newBalance: fixedBalance } 
        });
        window.dispatchEvent(event);
        // NOTE: Do NOT write to DB here — the backend already deducts on createTrade
        // and adds back on tradeProcessor. Writing here would corrupt balance.
    }

    getBalance() {
        const currentUser = this.state.currentUser;
        if (!currentUser) return;
        
        UserService.getUserBalance().then((response) => {
            let balance = 0;
            if (response.data && response.data.balance !== undefined) {
                balance = parseFloat(response.data.balance);
            } else if (response.data && typeof response.data === 'number') {
                balance = parseFloat(response.data);
            } else if (response.balance !== undefined) {
                balance = parseFloat(response.balance);
            }
            
            this.setState({ currentUSD: balance.toFixed(2) });
        }).catch(err => {
            this.setState({ currentUSD: "Error" });
        });
    }

    submitOrder() {
        const currentUser = AuthService.getCurrentUser();
        const { tradeAmount, currentUSD, selectedTime, profitPercent, tradeDirection, symbol } = this.state;
        
        if (!currentUser || !currentUser.id) {
            alert("Session expired or invalid. Please log in again.");
            this.redirectToLogin();
            return;
        }

        if (!tradeAmount || tradeAmount <= 0) {
            alert("Please enter a valid amount");
            return;
        }
        
        const amount = parseFloat(tradeAmount);
        const balance = parseFloat(currentUSD);
        
        if (amount > balance) {
            alert("Insufficient balance");
            return;
        }
        
        if (amount < 1) {
            alert("Minimum trade amount is 1");
            return;
        }

        const newBalance = balance - amount;
        this.updateGlobalBalance(newBalance);
        this.setState({ showTradeModal: false, loading: true });

        const profitAmount = amount * (profitPercent / 100);
        const result_payout = amount + profitAmount;

        const tradeData = {
            userId: currentUser.id,
            currency: symbol.toUpperCase() + "/USDT",
            orderAmount: amount,
            direction: tradeDirection === 'up' ? 'Buy Up' : 'Buy Down',
            billingTime: selectedTime.toString(),
            result_payout: result_payout,
            status: 'pending'
        };

        console.log("Submitting trade:", tradeData);

        TradeService.createTrade(tradeData)
            .then(response => {
                this.setState({ loading: false });
                
                // Fetch fresh balance from DB after trade is created
                this.getBalance();
                
                console.log("Trade created, redirecting to orders...");
                
                setTimeout(() => {
                    this.props.history.push({ 
                        pathname: "/orders", 
                        state: { defaultTab: 'Pending' } 
                    });
                }, 500);
            })
            .catch(error => {
                console.error("Trade failed:", error);
                
                let errorMessage = "Failed to create trade. ";
                if (error.response) {
                    errorMessage += error.response.data.message || 'Server Error';
                } else {
                    errorMessage += error.message;
                }
                
                alert(errorMessage);
                this.setState({ loading: false });
                
                // Restore balance from DB on failure
                this.getBalance();
            });
    }

    openTradeModal(direction) {
        if (!this.state.currentUser) {
            alert("Please log in to place trades");
            this.redirectToLogin();
            return;
        }

        this.getBalance(); 
        
        this.setState({
            showTradeModal: true,
            tradeDirection: direction,
            tradeAmount: '',
            selectedTime: 30,
            profitPercent: 20
        });
    }

    selectTime(time, profit) {
        this.setState({
            selectedTime: time,
            profitPercent: profit
        });
    }

    render() {
        const {
            currentUser, currentUSD, price, symbol, logo,
            showTradeModal, tradeDirection, selectedTime, profitPercent,
            changeD, high24, low24, vol24, volCoin, priceChange, txCount,
            loading, isLoadingData, apiError, isActiveCoin
        } = this.state;

        if (!currentUser) {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#131821', color: 'white' }}>
                    <div className="text-center">
                        <div className="simple-loading-circle"></div>
                        <p className="mt-2">Loading session...</p>
                    </div>
                </div>
            );
        }

        const timeOptions = [
            { time: 30, profit: 20 },
            { time: 60, profit: 30 },
            { time: 120, profit: 40 },
            { time: 180, profit: 50 },
            { time: 240, profit: 60 }
        ];
        
        // Determine color based on change
        const parsedChange = parseFloat(changeD);
        const isPositive = !isNaN(parsedChange) && parsedChange >= 0;
        const colorClass = isPositive ? "#0ecb81" : "#f6465d";

        return (
            <Container fluid className="coin-page-container">
                <AppHeader />

                {/* === DESKTOP CURRENCY SELECTOR === */}
                <div className="desktop-currency-selector">
                    <Dropdown>
                        <Dropdown.Toggle variant="dark" id="dropdown-basic" className="currency-dropdown">
                            <img src={logo} alt="logo" style={{ width: '20px', marginRight: '8px' }} />
                            {symbol.toUpperCase()}/USDT
                            {!isActiveCoin && <span className="badge badge-warning ml-2">Simulated</span>}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="currency-dropdown-menu">
                            {COIN_MAP.map((coinItem, index) => (
                                <Dropdown.Item
                                    key={index}
                                    onClick={() => this.changeCoin(coinItem)}
                                    className="currency-dropdown-item"
                                >
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <div className="d-flex align-items-center">
                                            <img src={coinItem.img} alt={coinItem.code} style={{ width: '20px', marginRight: '10px' }} />
                                            <span>{coinItem.code}/USDT</span>
                                        </div>
                                        {!coinItem.isActive && <span className="badge badge-secondary">Sim</span>}
                                    </div>
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* === MOBILE HEADER === */}
                <div className="mobile-top-stats">
                    <div className="mobile-nav-row">
                        <div className="mobile-stats-header" style={{ width: '100%', textAlign: 'center' }}>
                            <strong>{symbol.toUpperCase()}/USDT</strong>
                            {!isActiveCoin && <span className="badge badge-warning ml-2">Simulated</span>}
                        </div>
                    </div>

                    <div className="mobile-stats-grid">
                        <div className="mobile-price-col">
                            <div className="mobile-label">Latest Price</div>
                            {isLoadingData ? (
                                <div className="mobile-main-price text-muted">Loading...</div>
                            ) : (
                                <div className="mobile-main-price" style={{ color: colorClass }}>{price}</div>
                            )}
                            <div className="mobile-label mt-1">24H Change</div>
                            {isLoadingData ? (
                                <div className="mobile-change-val text-muted">Loading...</div>
                            ) : (
                                <div className="mobile-change-val" style={{ color: colorClass }}>{priceChange} ({changeD}%)</div>
                            )}
                        </div>

                        <div className="mobile-details-col">
                            <div className="m-stat-row"><span>High</span> <span>{isLoadingData ? "..." : high24}</span></div>
                            <div className="m-stat-row"><span>Low</span> <span>{isLoadingData ? "..." : low24}</span></div>
                            <div className="m-stat-row"><span>Vol(USDT)</span> <span>{isLoadingData ? "..." : vol24}</span></div>
                            <div className="m-stat-row"><span>Vol({symbol.toUpperCase()})</span> <span>{isLoadingData ? "..." : volCoin}</span></div>
                            <div className="m-stat-row"><span>Txns</span> <span>{isLoadingData ? "..." : txCount}</span></div>
                        </div>
                    </div>
                    
                    {apiError && (
                        <div className="alert alert-warning mt-2 mb-0 p-2 text-center">
                            <small>⚠️ Using simulated data for this coin</small>
                        </div>
                    )}
                </div>

                {/* === MAIN LAYOUT === */}
                <Row className="coin-main-row">
                    <Col lg={8} xs={12} className="chart-col m-0 p-0 pb-2 pl-2 bg-dark">
                        <div className="rounded w-100 chart-wrapper">
                            {isLoadingData ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: '500px', backgroundColor: '#131821' }}>
                                    <div className="text-center">
                                        <div className="simple-loading-circle"></div>
                                        <p className="text-muted mt-2">Loading chart data...</p>
                                    </div>
                                </div>
                            ) : (
                                <TradingViewWidget
                                    autosize
                                    symbol={isActiveCoin ? `BINANCE:${symbol.toUpperCase()}USDT` : "BINANCE:BTCUSDT"}
                                    interval="D"
                                    theme="Dark"
                                    locale="en"
                                    toolbar_bg="#131821"
                                    enable_publishing={false}
                                    hide_top_toolbar={false}
                                    hide_side_toolbar={false}
                                    hide_legend={false}
                                    allow_symbol_change={true}
                                    save_image={false}
                                    container_id="tradingview_widget"
                                    style="1"
                                />
                            )}
                        </div>
                    </Col>

                    <Col lg={4} xs={12} className="desktop-sidebar m-0 p-0 pr-2 pb-2 pl-2">
                        {/* Desktop Sidebar with 5 metrics */}
                        <div className="market-stats-container">
                            <div className="d-flex align-items-center mb-3 pb-2" style={{ borderBottom: '1px solid #2a2e39' }}>
                                <img src={logo} alt="logo" style={{ width: '30px', marginRight: '10px' }} />
                                <div>
                                    <h4 className="text-light m-0 font-weight-bold">{symbol.toUpperCase()}/USDT</h4>
                                    {!isActiveCoin && <small className="text-warning">Simulated Data</small>}
                                </div>
                            </div>

                            {isLoadingData ? (
                                <div className="text-center py-5">
                                    <div className="simple-loading-circle"></div>
                                    <p className="text-muted mt-2">Loading market data...</p>
                                </div>
                            ) : (
                                <div className="market-content-wrapper" style={{ display: 'block' }}>
                                    <div className="mb-4">
                                        <div className="text-muted mb-1">Latest Price</div>
                                        <div className="main-price-text" style={{ color: colorClass, fontSize: '32px', lineHeight: '1', fontWeight: 'bold' }}>{price}</div>
                                        <div className="mt-1">
                                            <span className="text-muted">24H Rise Fall </span>
                                            <span style={{ color: colorClass, fontWeight: 'bold' }}>{priceChange} ({changeD}%)</span>
                                        </div>
                                    </div>

                                    <div className="stats-list">
                                        <div className="d-flex justify-content-between mb-2" style={{ borderBottom: '1px solid #2a2e39', paddingBottom: '5px' }}>
                                            <span className="text-muted">24H Highest Price</span>
                                            <span className="text-light font-weight-bold">{high24}</span>
                                        </div>

                                        <div className="d-flex justify-content-between mb-2" style={{ borderBottom: '1px solid #2a2e39', paddingBottom: '5px' }}>
                                            <span className="text-muted">24H Lowest Price</span>
                                            <span className="text-light font-weight-bold">{low24}</span>
                                        </div>

                                        <div className="d-flex justify-content-between mb-2" style={{ borderBottom: '1px solid #2a2e39', paddingBottom: '5px' }}>
                                            <span className="text-muted">24H Volume(USDT)</span>
                                            <span className="text-light font-weight-bold">{vol24}</span>
                                        </div>

                                        <div className="d-flex justify-content-between mb-2" style={{ borderBottom: '1px solid #2a2e39', paddingBottom: '5px' }}>
                                            <span className="text-muted">24H Volume({symbol.toUpperCase()})</span>
                                            <span className="text-light font-weight-bold">{volCoin}</span>
                                        </div>

                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="text-muted">24H Transactions</span>
                                            <span className="text-light font-weight-bold">{txCount}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="trading-section rounded p-3 mt-3" style={{ backgroundColor: "#131821", border: "2px solid #2a2e39" }}>
                            <div className="text-center mb-4"><h5 className="text-light">Fixed Time Trading</h5></div>
                            <Row>
                                <Col>
                                    <Button
                                        className="w-100 btn-buy-up py-3"
                                        onClick={() => this.openTradeModal('up')}
                                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                                        disabled={isLoadingData}
                                    >
                                        {isLoadingData ? 'Loading...' : 'Buy Up'}
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        className="w-100 btn-buy-down py-3"
                                        onClick={() => this.openTradeModal('down')}
                                        style={{ fontSize: '16px', fontWeight: 'bold' }}
                                        disabled={isLoadingData}
                                    >
                                        {isLoadingData ? 'Loading...' : 'Buy Down'}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>

                <div className="mobile-trade-footer">
                    <Button className="btn-buy-up" onClick={() => this.openTradeModal('up')} disabled={isLoadingData}>
                        {isLoadingData ? '...' : 'Buy Up'}
                    </Button>
                    <Button className="btn-buy-down" onClick={() => this.openTradeModal('down')} disabled={isLoadingData}>
                        {isLoadingData ? '...' : 'Buy Down'}
                    </Button>
                </div>

                {/* TRADE MODAL */}
                <Modal show={showTradeModal} onHide={() => this.setState({ showTradeModal: false })} centered className="dark-modal">
                    <Modal.Header closeButton style={{ backgroundColor: '#1e2329', color: 'white', borderBottom: '1px solid #444' }}>
                        <Modal.Title>
                            {tradeDirection === 'up' ?
                                <span className="text-success">Buy Up 🔼</span> :
                                <span className="text-danger">Buy Down 🔽</span>
                            }
                            {!isActiveCoin && <span className="badge badge-warning ml-2">Simulated</span>}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: '#131821', color: 'white' }}>
                        <p>Balance: <b>{currentUSD}</b></p>
                        <p className="mb-2"><b>Select Time</b></p>
                        <Row className="mb-3">
                            {timeOptions.map((opt) => (
                                <Col key={opt.time} xs={4} className="mb-2">
                                    <div
                                        className={`time-selector-box ${selectedTime === opt.time ? 'active' : ''}`}
                                        onClick={() => this.selectTime(opt.time, opt.profit)}
                                        style={{
                                            padding: '8px',
                                            border: selectedTime === opt.time ? '2px solid #0ecb81' : '1px solid #444',
                                            borderRadius: '5px',
                                            textAlign: 'center',
                                            cursor: 'pointer',
                                            backgroundColor: selectedTime === opt.time ? '#0ecb8120' : 'transparent'
                                        }}
                                    >
                                        <div className="time-text" style={{ fontWeight: 'bold' }}>{opt.time}s</div>
                                        <div className="profit-text" style={{ color: '#0ecb81', fontSize: '12px' }}>{opt.profit}%</div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                        <Form.Group>
                            <Form.Label><b>Amount</b></Form.Label>
                            <Form.Control
                                type="number"
                                className="custom-input"
                                placeholder="Enter Amount"
                                value={this.state.tradeAmount}
                                onChange={(e) => this.setState({ tradeAmount: e.target.value })}
                                style={{ backgroundColor: '#1e2329', color: 'white', border: '1px solid #444' }}
                            />
                        </Form.Group>
                        <div className="summary-row mt-4 d-flex justify-content-between">
                            <span>{symbol.toUpperCase()}</span>
                            <span>Price: {price}</span>
                            <span>Profit: {profitPercent}%</span>
                        </div>
                        <Button
                            className="w-100 mt-3 font-weight-bold"
                            onClick={this.submitOrder}
                            style={{
                                backgroundColor: tradeDirection === 'up' ? '#0ecb81' : '#f6465d',
                                border: 'none',
                                padding: '12px',
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }}
                        >
                            {loading ? 'Processing...' : 'Submit Order'}
                        </Button>
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.showResultModal} onHide={() => this.setState({ showResultModal: false })} centered>
                    <Modal.Body style={{ backgroundColor: '#131821', color: 'white', textAlign: 'center' }}>
                        <h3>{this.state.tradeResult}</h3>
                        <Button onClick={() => this.setState({ showResultModal: false })} className="mt-3">Close</Button>
                    </Modal.Body>
                </Modal>
            </Container>
        );
    }
}
